import ninjaApi from 'store/redux/apis/ninja.api';

export const tiktokApi = ninjaApi.injectEndpoints({
  overrideExisting: true,
  tagTypes: ['NetworkAccount'],
  endpoints: (build) => ({
    /* Login facebook Account */
    connectTiktok: build.mutation({
      query: (data) => ({
        url: '/apps/tiktok/auth/connect',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['NetworkAccount'],
    }),
  }),
});

export const { useConnectTiktokMutation } = tiktokApi;
